import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreatePollInput, Poll } from '@avslack/shared';
import { apiFetch } from '../lib/api';

/**
 * SZAVAZAS (versenyaudit U4).
 *
 * Szavazasonkent egy lekerdezes. A csatorna `poll.updated` esemenye (valaki
 * szavazott, vagy lezartak) ervenytelenitit - igy az eredmeny elo.
 */
export const pollKey = (pollId: string) => ['poll', pollId] as const;

export function usePoll(pollId: string) {
  return useQuery({
    queryKey: pollKey(pollId),
    queryFn: () => apiFetch<{ poll: Poll }>(`/api/polls/${pollId}`).then((r) => r.poll),
    staleTime: 60_000,
    /*
      A hatarido magatol jar le - esemeny nem jon rola. Amig nyitott es van
      hatarideje, percenkent ranezunk, hogy a "lezarult" allapot megjelenjen.
    */
    refetchInterval: (query) => {
      const poll = query.state.data;
      return poll && !poll.isClosed && poll.closesAt ? 60_000 : false;
    },
  });
}

export function useVotePoll(pollId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (optionIds: string[]) =>
      apiFetch<{ poll: Poll }>(`/api/polls/${pollId}/vote`, {
        method: 'POST',
        body: JSON.stringify({ optionIds }),
      }).then((r) => r.poll),
    onSuccess: (poll) => queryClient.setQueryData(pollKey(pollId), poll),
  });
}

export function useClosePoll(pollId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiFetch<{ poll: Poll }>(`/api/polls/${pollId}/close`, { method: 'POST' }).then(
        (r) => r.poll,
      ),
    onSuccess: (poll) => queryClient.setQueryData(pollKey(pollId), poll),
  });
}

export function useCreatePoll(channelId: string) {
  return useMutation({
    mutationFn: (input: CreatePollInput) =>
      apiFetch<{ poll: Poll }>(`/api/channels/${channelId}/polls`, {
        method: 'POST',
        body: JSON.stringify(input),
      }).then((r) => r.poll),
  });
}
